import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  modal: {
    '& .MuiPaper-root': {
      minWidth: spacing(550),
      maxWidth: 'min(900px, calc(100vw - 32px))',
    },
  },
  divider: {
    backgroundColor: '#E3E3E3',
    height: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(24),
    padding: `${spacing(24, 16)} !important`,
    width: '100%',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: spacing(20),
  },
}))
